import { api } from "../../../services/api";
import React, { useEffect, useState } from "react";
import {
    Container,
    ElementContainer,
    Section,
} from "./../../../styles/Adm/IndexPages/styles";
import { StyledButton } from "./../../../styles/Adm/IndexPages/styles";
import { AiFillDelete } from "react-icons/ai";
import { MdEdit } from "react-icons/md";
import Button from "../../../components/Button";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const IndexProviderPage = () => {
    const [providers, setProviders] = useState([]);

    useEffect(() => {
        api.get("/providers/")
            .then((response) => {
                setProviders(response.data);
            })
            .catch((e) => {
                const data = e.response.data;
                toast.error(
                    data?.error
                        ? data.error
                        : data?.message
                        ? data.message
                        : e.message
                );
            });
    }, []);

    const deleteProvider = (id) => {
        let confirmDelete = window.confirm(
            "Tem certeza que quer excluir esse fornecedor?"
        );
        if (confirmDelete) {
            api.delete(`/providers/delete/${id}`)
                .then(() => {
                    toast.success("Fornecedor deletado");
                    setProviders((providers) =>
                        providers.filter((pr) => pr.id !== id)
                    );
                })
                .catch((er) => {
                    switch (er?.response?.status) {
                        case 401:
                            toast.error(
                                "O usuário não pode ser autenticado. Caso realmente seja um administrador, tente sair e entrar novamente na conta."
                            );
                            break;

                        default:
                            toast.error(er.message);
                            break;
                    }
                });
        }
    };

    return (
        <>
            <Section>
                <div className="title-container">
                    <h1> Gerencie seus Fornecedores </h1>
                </div>

                <div className="head-container">
                    <div className="table-titles">
                        <div className="containers">
                            <h2> Nome do Fornecedor </h2>
                        </div>
                        <div className="containers">
                            <h2> Ações </h2>
                        </div>
                    </div>
                </div>

                <Container>
                    {providers.map((item, index) => (
                        <ElementContainer key={item.id}>
                            <div className="containers">
                                <Link to={`./${item.id}`}>
                                    <span> {item.name} </span>
                                </Link>
                            </div>
                            <div className="containers">
                                <Link to={`./editar/${item.id}`}>
                                    <StyledButton
                                        variant="contained"
                                        endIcon={<MdEdit size={14} />}
                                        className="small-font"
                                    >
                                        Editar
                                    </StyledButton>
                                </Link>
                                <StyledButton
                                    variant="contained"
                                    type="button"
                                    className="small-font"
                                    onClick={() => deleteProvider(item.id)}
                                    endIcon={<AiFillDelete size={14} />}
                                >
                                    Excluir
                                </StyledButton>
                            </div>
                        </ElementContainer>
                    ))}
                </Container>

                <Link to="./criar">
                    <Button>Adicionar Fornecedor</Button>
                </Link>
            </Section>
        </>
    );
};
export default IndexProviderPage;